export default {
    noResultsText: 'No se encontraron resultados',
    noChoicesText: 'No hay opciones para elegir',
    itemSelectText: 'Presione para seleccionar',
    uniqueItemText: 'Solo se pueden agregar valores únicos',
    customAddItemText: 'Solo se pueden agregar valores que coincidan con condiciones específicas',
    apiSearching: 'Buscando...',
    // addItemText: value => `Press Enter to add <b>"${sanitise(value)}"</b>`,
    // maxItemText: maxItemCount => `Only ${maxItemCount} values can be added`,
    customChoiceValue: 'Otro',
}
